module.exports = __webpack_public_path__ + "static/media/Group_1000006768.60f5f255.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Group_1000006768.png
// module id = 1610
// module chunks = 0